<template>
  <div class="welcome">
    <div class="hero-header">
      <h1>Get a permanent timestamp for any document, for free</h1>
      <p class="tagline">Timestamp allows you to post a verification of a message or file and submit its traceable, timestamped proof on the blockchain.</p>
    </div>

    <CreateTimestamp />
  </div>
</template>

<script>
import CreateTimestamp from '@/components/CreateTimestamp.vue'

export default {
  name: 'New',
  components: {
    CreateTimestamp
  }
}
</script>

<style>
.hero-header h1 {
  font-size: 32px;
  line-height: 40px;
  max-width: 480px;
}
.hero-header .tagline {
  color: #555;
  font-size: 16px;
  line-height: 24px;
  max-width: 520px;
}
.hero-actions {
  display: flex;
  margin: 32px 0;
}
.hero-actions .primary-cta {
  display: block;
  font-size: 16px;
  line-height: 24px;
  background: #00EF71;
  color: #0F0F0F;
  border-radius: 4px;
  padding: 12px 24px;
  font-weight: bold;
  border: 0;
}
.hero-actions a:hover {
  text-decoration: none;
}
.hero-actions .secondary-cta {
  display: block;
  font-size: 16px;
  line-height: 24px;
  background: transparent;
  color: #00EF71;
  padding: 12px 24px;
}

.features h2, .use-cases h2 {
  font-size: 24px;
  line-height: 32px;
  margin: 48px 0 24px 0;
}

.feature-block {
  display: flex;
  align-items: flex-start;
  margin: 28px 0;
}
.feature-block img {
  flex-grow: 0;
  margin: 8px 24px 0 0;
}

.feature-block h3 {
  margin: 0 0 4px 0;
  font-size: 16px;
  line-height: 24px;
}
.feature-block p {
  color: #BFBFBF;
  font-size: 14px;
  line-height: 20px;
  margin: 0;
}
</style>
